import GlobalWebhookDetails from './GlobalWebhookDetails';
import WebhookActions from './WebhookActions';
import React, { useState } from 'react';
import GlobalWebhookCreateSection from './GlobalWebhookCreateSection';
import { Card } from '@mui/material';

const GlobalWebhook = ({ webhook }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const closeMenu = () => setAnchorEl(null);

  return (
    <Card
      sx={{
        background: 'grey.900',
        borderRadius: 2,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        mb: 1,
      }}
    >
      {webhook.length > 0 ? (
        <>
          <GlobalWebhookDetails webhook={webhook[0]} onOpenMenu={openMenu} />
          <WebhookActions selectedWebhook={webhook[0]} anchorEl={anchorEl} onClose={closeMenu} isGlobal={true} />
        </>
      ) : (
        <GlobalWebhookCreateSection />
      )}
    </Card>
  );
};

export default GlobalWebhook;
